import _ from 'lodash';
import { InputContainer } from '../../../../../common/components/form/form.module';


export const AggregationPolicyDetailsComponent = ({
  selectedTierPriceValues,
  onFormTierPriceItemChange,
  DSAPAgents,
  onFormTierPriceIChange,
  selectedProgram,
  DSAPAgencies
}: any) => {
  
  return (
    <>
      {_.map(selectedTierPriceValues, (selectedTierPriceValue: any, index: any) => (
        <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-4 border p-4" key={index}>
          {selectedProgram?.AggregationTypeId === 1005 &&
          <InputContainer
            label="Name"
              labelField="Name"
              list={DSAPAgents}
            onValueChange={(event: any) => {
              onFormTierPriceItemChange({
                value: event.target.value,
                field: 'EntityId',
                idx: index,
              });
            }}
            optionName='Choose DSAP Agents'
            type="select"
            value={selectedTierPriceValue?.EntityId}
             valueField="Id"
          />}

{selectedProgram?.AggregationTypeId === 1004 &&
          <InputContainer
            label="Name"
              labelField="Name"
              list={DSAPAgencies}
            onValueChange={(event: any) => {
              onFormTierPriceItemChange({
                value: event.target.value,
                field: 'EntityId',
                idx: index,
              });
            }}
            optionName='Choose DSAP Agencies'
            type="select"
            value={selectedTierPriceValue?.EntityId}
             valueField="Id"
          />}

          <div className="col-span-full">
            <table className="w-full text-sm text-gray-500 border-2">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 border-b-2">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    Price
                  </th>
                  <th scope="col" className="px-6 py-3">
                    ReferralFee Percentage
                  </th>
                  <th scope="col" className="px-6 py-3">
                    ReferralFee Cost
                  </th>
                  <th scope="col" className="px-6 py-3">
                    ClosingFee Percentage
                  </th>
                  <th scope="col" className="px-6 py-3">
                    ClosingFee Cost
                  </th>
                </tr>
              </thead>
              <tbody>
                {_.map(selectedTierPriceValue?.Aggregations, (tierprice: any, index1: any) => (
                  <tr className="bg-white border-b" key={index1}>
                    <td className="px-6 py-4">
                      <InputContainer
                        label="Price"
                        name="Price"
                        onValueChange={(event: any) => {
                          onFormTierPriceIChange({
                            value: event.target.value,
                            field: 'Price',
                            idx: index1,
                            cardValue: selectedTierPriceValue,
                            idx1: index,
                          });
                        }}
                        type="number"
                        value={tierprice?.Price}
                      />
                    </td>
                    <td className="px-6 py-4">
                      <InputContainer
                        label="ReferralFee Percentage"
                        name="ReferralFee Percentage"
                        onValueChange={(event: any) => {
                          onFormTierPriceIChange({
                            value: event.target.value,
                            field: 'ReferralFee.Percentage',
                            idx: index1,
                            cardValue: selectedTierPriceValue,
                            idx1: index,
                          });
                        }}
                        type="number"
                        value={tierprice?.ReferralFee?.Percentage}
                      />
                    </td>
                    <td className="px-6 py-4">
                      <InputContainer
                        label="ReferralFee Cost"
                        name="ReferralFee Cost"
                        onValueChange={(event: any) => {
                          onFormTierPriceIChange({
                            value: event.target.value,
                            field: 'ReferralFee.Cost',
                            idx: index1,
                            cardValue: selectedTierPriceValue,
                            idx1: index,
                          });
                        }}
                        type="number"
                        value={tierprice?.ReferralFee?.Cost}
                      />
                    </td>
                    <td className="px-6 py-4">
                      <InputContainer
                        label="ClosingFee Percentage"
                        name="ClosingFee Percentage"
                        onValueChange={(event: any) => {
                          onFormTierPriceIChange({
                            value: event.target.value,
                            field: 'ClosingFee.Percentage',
                            idx: index1,
                            cardValue: selectedTierPriceValue,
                            idx1: index,
                          });
                        }}
                        type="number"
                        value={tierprice?.ClosingFee?.Percentage}
                      />
                    </td>
                    <td className="px-6 py-4">
                      <InputContainer
                        label="ClosingFee Cost"
                        name="ClosingFee Cost"
                        onValueChange={(event: any) => {
                          onFormTierPriceIChange({
                            value: event.target.value,
                            field: 'ClosingFee.Cost',
                            idx: index1,
                            cardValue: selectedTierPriceValue,
                            idx1: index,
                          });
                        }}
                        type="number"
                        value={tierprice?.ClosingFee?.Cost}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </>
  );
};
export default AggregationPolicyDetailsComponent;
